export * from './char-counter.component';
